import { motion } from "framer-motion";
import React, { useState } from "react";
import { Collapse } from "reactstrap";

import typePalettes from "./utils/typePalettes";

interface WarningBannerProps {
  title: React.ReactNode;
  text?: React.ReactNode;
  type: keyof typeof typePalettes;
}

const WarningBanner = ({ title, text, type }: WarningBannerProps) => {
  const [isOpen, setOpen] = useState(false);
  const { icon, className = "bg-white" } = typePalettes[type] || {};
  return (
    <motion.div
      onClick={() => text && setOpen(!isOpen)}
      transition={{ duration: 0.3 }}
      style={{ cursor: text ? "pointer" : undefined }}
      className={"w-100 m-0 p-0 py-3 " + className}
    >
      <div className="d-flex justify-content-between align-items-center py-1 px-4" style={{ fontWeight: "700" }}>
        <div className="flex-center">
          {icon && <i className={icon + " mr-2"} style={{ fontSize: "1.7rem" }} />}
          {title}
        </div>
        {text && (
          <motion.i
            className="fas fa-chevron-down"
            animate={{ transform: isOpen ? "rotate(180deg)" : "rotate(0deg)" }}
          />
        )}
      </div>
      {text && (
        <Collapse isOpen={isOpen} className="px-4" style={{ fontWeight: "400" }}>
          <div className="w-100 mt-3" />
          <div dangerouslySetInnerHTML={{ __html: String(text) }} />
        </Collapse>
      )}
    </motion.div>
  );
};

export default WarningBanner;
